import { DEALER_TYPES } from '~/constants'
import Cookie from 'js-cookie'
import { postData } from '~/utils/api'

export const urlIsAbsolute = (url: string): boolean =>
  new RegExp('^(?:[a-z]+:)?//', 'i').test(url)

export const isNoAuthPage = (pathname: string): boolean =>
  pathname === '/login' || pathname === '/_error' || pathname === '/insales'

export const findDealer = (dealers = [], dealerId: string) =>
  dealers.find(
    //@ts-ignore
    (dealer: DEALER) => dealer.id === dealerId,
  )

export const getDefaultRedirect = (type: string): string =>
  `/${type.toLowerCase()}/${type === DEALER_TYPES.PPN ? 'orders' : 'dashboard'}`

export const updatePPNOrder = async ({
  action,
  uuid,
  pin_code = '',
  onError,
  onSuccess,
}) => {
  const { access_token, access_realm } = Cookie.get()
  const { error, actionCompleted } = await postData(
    `/api/v1/ppn-set-status`,
    {
      uuid,
      pin_code,
      action,
    },
    {
      access_token,
      access_realm,
    },
  )

  if (!error) {
    if (typeof onSuccess !== undefined) onSuccess(actionCompleted)
  } else {
    if (typeof onError !== undefined) onError(error)
  }
}

export const fillTrackingTemplate = (order) => {
  if (!order.tracking_url_template) return null;

  let keyNotFound = false;
  const url = order.tracking_url_template.replace(/{{(\w+)}}/g, (_, key) => {
    if (order[key]) {
      return order[key];
    } else {
      keyNotFound = true;
      return null;
    }
  });

  return keyNotFound ? null : url;
}

export const getItemsCount = (order) => {
  let itemsCount = 0
  const orderItems = order?.orderItems
  if (orderItems) {
    Object.keys(orderItems).forEach(i => {
      const item = orderItems[i]
      itemsCount += +item?.Quantity || +item?.quantity || 1
    })
  }
  return itemsCount
}